import styles from "./index.module.css";
import { Link } from "react-router-dom";

import { Button } from "@primer/react";
import useMediaQuery from "../../customHooks";
import Redirect from "../Images/redirect";
import ThemeToggle from "../ThemeToggle";

const Navbar = () => {
  const isMobile = useMediaQuery("(max-width: 1020px)");

  return (
    <header className={styles.nav}>
      <div className={styles.navContainer}>
        <Link to="https://changelog.testmuai.com">
          <div className={styles.navTitleContainer}>
            <img
              src="../../testmu-logo.svg"
              alt="TestMu AI Logo"
              height="26"
              width="auto"
            />
            <h1 className={styles.navTitle}>TestMu AI (Formerly LambdaTest) Announcements</h1>
          </div>
        </Link>
        <div className={styles.navActions}>
          <ThemeToggle />
          <Button
            variant="primary"
            size="small"
            style={{
              fontWeight: 600,
            }}
            onClick={() => {
              window.open("https://www.testmuai.com");
            }}
            trailingVisual={Redirect}
          >
            Go to Website
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
